import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';
@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  styleUrls: ['./edit-notification.component.scss']
})
export class EditNotificationComponent {
uploader: CloudinaryUploader = new CloudinaryUploader(
        new CloudinaryOptions({ cloudName: 'ocomedia', uploadPreset: 'ui0cyga0' })
    );
 url:any='';



newsDetails:any={};
newsdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase,public toastr: ToastrService) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	if(Id != null) {
		        this.newsdata = this.af.object('/FoonYew2/' + Id);
		        this.newsdata.subscribe(
		        (response) => { 
		        	this.newsDetails = response;
		         }
		      )
          }
       });
  	 	this.uploader.onBeforeUploadItem = (item: any) => {
            item.url = this.uploader.options.url;
            console.log("image is going")
            localStorage.setItem("image" ,"image Is going");
            return item;
        };
  }
     //Image Preview
      readUrl(event) {
                 if (event.target.files && event.target.files[0]) {
                 var reader = new FileReader();
               reader.onload = (event:any) => {
                 this.url = event.target.result;
                 //this.imageRef = 1;
               }

             reader.readAsDataURL(event.target.files[0]);
             }
           }

           //Submit function

    onSubmitNews(form: NgForm){
       this.uploader.uploadAll();
       console.log("statement");
           this.uploader.onSuccessItem = (item: any, response: string, status: number, headers: any): any => {
            let res: any = JSON.parse(response); 
            console.log("statement");
              this.newsdata.update({
              id:this.newsDetails.id,
              title:this.newsDetails.title,
              fullContent:this.newsDetails.fullContent,
              featuredImageURL: res.url,
              date:this.newsDetails.date,
              publish:this.newsDetails.publish,
              shortContent:this.newsDetails.shortContent,
        }).then((res)=>{
          localStorage.removeItem('image');
          this.router.navigate(['/notification/manageNotification']);
           this.toastr.success('news Data Updated Successfully!', 'Success!');
        });
        }
       if(localStorage.getItem("image")==null){
          console.log("if");
                this.newsdata.update({
            id:this.newsDetails.id,
            title:this.newsDetails.title,
            fullContent:this.newsDetails.fullContent,
            date:this.newsDetails.date,
            publish:this.newsDetails.publish,
            shortContent:this.newsDetails.shortContent,
          }).then((res)=>{
          this.router.navigate(['/notification/manageNotification']);
           this.toastr.success('news Data Updated Successfully!', 'Success!');
        });
       }
    }
    cancel(){
       this.router.navigate(['/notification/manageNotification']);
    }
}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/notifications/edit-notification/edit-notification.component.ts